import React, { useEffect, useState } from 'react';
import './Tabs.scss';
import { Typography } from '@design-system/index';
import { useNavigate } from 'react-router-dom';
export type Tab = {
    label: string;
    path?: string;
    component: React.ReactNode;
    className?: string;
    isUnactive?: boolean;
};

type TabsProps = {
    tabs: (setActiveTab: (tab: number) => void) => Tab[];
    orientation?: 'horizontal' | 'vertical';
    defaultActiveTab?: number;
    className?: string;
};

export const Tabs: React.FC<React.PropsWithChildren & TabsProps> = ({ tabs, orientation = "horizontal", defaultActiveTab = 0, className }) => {
    const [activeTab, setActiveTab] = useState(defaultActiveTab);
    const navigate = useNavigate();
    
    useEffect(() => {
        if (tabsList[activeTab].path) {
            navigate(tabsList[activeTab].path);
        }
    }, [activeTab]);

    const tabsList = tabs(setActiveTab);
    return (
        <div className={`tabs-container ${className}`} data-orientation={orientation}>
            <div className="tabs-list">
                {tabsList.map((tab, index) => (
                    <div key={index} className={`tabs-list-item ${activeTab === index ? 'active' : ''} ${tab.isUnactive ? 'disabled' : ''}`} onClick={() => {setActiveTab(index)}}>
                        <Typography intrinsic="h3" variant="secondary">{tab.label}</Typography>
                    </div>
                ))}
            </div>
            <div className="tab-content">
                {tabsList[activeTab].component}
            </div>
        </div>
    );
};
